import {
  ClipboardList,
  Calculator,
  FileSearch,
  Gauge,
  ListChecks,
  KeyRound,
  MailPlus,
  ScrollText,
  Users,
  type LucideIcon,
  UtensilsCrossed,
} from "lucide-react";
import type { Permission } from "@ir/types";

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Hidden entirely when the signed-in user lacks this. */
  permission?: Permission;
  /** Match only the exact path, for index routes. */
  end?: boolean;
  description?: string;
}

export interface NavSection {
  id: string;
  label: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    id: "operations",
    label: "Operations",
    items: [
      {
        label: "Overview",
        to: "/",
        icon: Gauge,
        end: true,
        description: "Today's activity at a glance",
      },
      {
        label: "Quotes",
        to: "/quotes",
        icon: ClipboardList,
        permission: "quotes.view",
        description: "Search and inspect quote records",
      },
      {
        label: "Leads",
        to: "/leads",
        icon: ListChecks,
        permission: "leads.view",
        description: "Raw submissions from the quote form",
      },
    ],
  },
  {
    id: "tools",
    label: "Tools",
    items: [
      
      {
        label: "Quote Finder",
        to: "/quote-finder",
        icon: FileSearch,
        permission: "quotes.search",
        description: "Look up every quote for an email address",
      },
      // {
      //   label: "Retrieve from OGI",
      //   to: "/ogi-retrieve",
      //   icon: DownloadCloud,
      //   permission: "ogi.retrieve",
      //   description: "Pull an existing OpenGI quote into the marketplace",
      // },
      {
        label: "Fast Food Step Form",
        to: "/step-forms/fast-food",
        icon: UtensilsCrossed,
        permission: "stepforms.use",
        description: "Complete a quote on behalf of a customer",
      },{
        label: "Pricing Calculator",
        to: "/pricing-calculator",
        icon: Calculator,
        permission: "quotes.view",
        description: "Validate fast-food customer pricing",
      },
    ],
  },
  {
    id: "access",
    label: "Access",
    items: [
      {
        label: "Lead Partners",
        to: "/lead-partners",
        icon: KeyRound,
        permission: "partners.manage",
        description: "Credentials for third-party lead suppliers",
      },
      {
        label: "Users",
        to: "/users",
        icon: Users,
        permission: "users.manage",
        description: "Roles and access for staff",
      },
      {
        label: "Invites",
        to: "/invites",
        icon: MailPlus,
        permission: "invites.manage",
        description: "Outstanding and past invitations",
      },
      {
        label: "Audit Log",
        to: "/audit",
        icon: ScrollText,
        permission: "audit.view",
        description: "Who did what, and when",
      },
    ],
  },
];

/** External systems the operations team lives in day to day. */
export const HELPER_LINKS = [
  {
    label: "Granite Portal",
    href: "https://agent.graniteunderwriting.co.uk/Account/Login.aspx",
  },
  {
    label: "Kinetiq Portal",
    href: "https://portal.kinetiqunderwriting.co.uk/",
  },
  {
    label: "Inshur Portal",
    href: "https://inshur.stoplight.io/auth",
  },
];
